import { PolicyNumber } from '@/components/common/PolicyNumber';

/**
 * The "Policy" column of both commission drill-downs.
 *
 * `policy_number` is our internal reference (`POL-716-godigit-260807-F798C6`);
 * `insurer_policy_number` is the number printed on the customer's policy
 * (`D210524290`). The reports showed only the former, which is why the column
 * read as a reference number rather than a policy number.
 *
 * Ours stays visible underneath, because support looks records up by it.
 */
export function PolicyNumberCell({
  policyNumber,
  insurerPolicyNumber,
}: {
  policyNumber?: string;
  insurerPolicyNumber?: string;
}) {
  const ours = policyNumber?.trim() ?? '';
  const theirs = insurerPolicyNumber?.trim() ?? '';

  if (!theirs && !ours) return <span>—</span>;

  return (
    <div>
      {/* Our reference, when it is all there is, carries the internal-ref tag. */}
      <PolicyNumber
        source={{ insurer_policy_number: theirs, policy_number: ours }}
        className="block font-medium text-gray-900 dark:text-gray-100"
      />
      {/* Only when both exist and differ — otherwise the same string twice. */}
      {theirs && ours && theirs !== ours && (
        <div className="text-xs text-gray-500 dark:text-gray-400">{ours}</div>
      )}
    </div>
  );
}
